// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-1-H6U","modal_rounded":"modal_rounded-2oy-l","closeIcon":"closeIcon-te75K","modalRounded":"modalRounded-3_L5S"};